import React, { useState } from 'react'
import { toast } from 'react-toastify'

import getRoutes from '@/lib/getRoutes'
import useAddProductBasket from '@/lib/hook/useAddProductBasket'
import { RecentProduct } from '@/lib/recentProducts'
import ProductGridCard, { CARD_WIDTH } from '@/components/Product/ProductGridCard'

export { CARD_WIDTH }

const RecentProductCard: React.FC<{
  item: RecentProduct
  onRemove: (slug: string) => void
}> = ({ item, onRemove }) => {
  const url = getRoutes({ route: 'Product', values: { '[slug]': item.slug } })
  const { addProductToBasket } = useAddProductBasket()
  const [loading, setLoading] = useState(false)

  const handleAddToCart = async () => {
    if (!item.product_id) return
    setLoading(true)
    try {
      await addProductToBasket([
        { product_id: item.product_id, amount: 1, product: item.name || '' },
      ])
      // @ts-ignore
      toast.success(t({ id: 'web_register_success' }))
    } catch {
      // @ts-ignore
      toast.error(t({ id: 'web_error' }))
    } finally {
      setLoading(false)
    }
  }

  return (
    <ProductGridCard
      productId={item.slug}
      name={item.name || ''}
      image={item.image || '/images/no-image.png'}
      brandName={item.brand_name}
      code={item.ean}
      price={item.base_price}
      href={url.href}
      as={url.as}
      loading={loading}
      onDelete={() => onRemove(item.slug)}
      onAddToCart={item.product_id ? handleAddToCart : undefined}
    />
  )
}

export default RecentProductCard
